import toastr from 'toastr';
import 'toastr/toastr.scss';

toastr.options = { positionClass: 'toast-bottom-center' };

export function warning(message: string, title?: string) {
  toastr.warning(message, title, {
    timeOut: 5000,
    progressBar: true
  });
}

export function success(message: string, title?: string) {
  toastr.success(message, title, {
    timeOut: 0,
    closeButton: true
  });
}
